import React, { useEffect, Component, useState, useRef } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory, useParams } from 'react-router-dom';
import { ApiService } from '../../containers/Services/apiservice';
import { Watch } from "react-loader-spinner";
let apiServices = new ApiService();
const MfRedeemDetail = () => {
  let history = useHistory();
  const { id } = useParams();
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [MFData, setMFData] = useState({});
  const [FoiloData, SetFoiloData] = useState([]);
  const [RedeemFoiloData, SetRedeemFoiloData] = useState([]);
  const [UserBankData, SetUserBankData] = useState({});
  const [Bankno, setBankno] = useState('1');
  const [RedeemType, SetRedeemType] = useState('A');
  const [RedeemVolume, SetRedeemVolume] = useState();
  const [FolioNumber, setFolioNumber] = useState();
  const [errorMessage, setErrorMessage] = useState('')
  const didMountRef = useRef(true);
  useEffect(() => {
    if (didMountRef.current) {
      getredeemfolios();
      getusrbanks();
    }
    didMountRef.current = false;
  });
  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }
  const getredeemfolios = () => {
    setSpinnerLoading(true);
    const dataString = {
      "id": atob(id),
    }
    apiServices.getredeemfoliosPostRequest(dataString).then(result => {
      if (result.data.status == 'success') {
        setMFData(result.data.redeemfunddata)
        SetFoiloData(result.data.data)
        setSpinnerLoading(false);
      }
      else if (result.data.status == "error" && result.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(result.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(result.data.message)
        setSpinnerLoading(false)
        return false
      }
    })
  }
  const makeredeemtransaction = () => {
    if (FolioNumber == '' || FolioNumber == null || FolioNumber == undefined) {
      setErrorMessage("Select Folio Number First");
      return false
    }
    else if (RedeemVolume == '' || RedeemVolume == null || RedeemVolume == undefined) {
      setErrorMessage("Please Enter Transaction Volume");
      return false
    } else if (RedeemType == 'A' && RedeemFoiloData.valueatnav < RedeemVolume) {
      setErrorMessage("Invalid Amount Entered");
      return false
    } else if (RedeemType == 'U' && RedeemFoiloData.totalunits < RedeemVolume) {
      setErrorMessage("Invalid Units Entered");
      return false
    }
    else {
      setErrorMessage('')
    }
    setSpinnerLoading(true);
    const dataString = {
      "txnVolumeType": RedeemType,
      "txnVolume": RedeemVolume,
      "folio": FolioNumber,
      "bankno": Bankno,
    }
    apiServices.redeemtransactionPostRequest(dataString).then(result => {
      console.log(result);
      if (result.data.status == 'success') {
        setTimeout(() => {
          history.push("/dashboard");
        }, 3000);
        setSpinnerLoading(false);
        openInNewTab(result.data.redirectURL)
      }
      else if (result.data.status == "error" && result.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(result.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(result.data.message)
        setSpinnerLoading(false)
        return false

      }
    })
    console.log(dataString);
  }
  const redeemfundData = (foliono) => {
    setFolioNumber(foliono);
    setSpinnerLoading(true);
    const dataString = {
      "folio": foliono,
    }
    apiServices.redeemfundDataPostRequest(dataString).then(result => {
      if (result.data.status == 'success') {
        SetRedeemFoiloData(result.data.data)
        setSpinnerLoading(false);
      } else if (result.data.status == "error" && result.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(result.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(result.data.message)
        setSpinnerLoading(false)
      }
    })
  }
  const getusrbanks = () => {
   const dataString = {
    }
    apiServices.getusercanbankdata(dataString).then(res => {
      if (res.data.status == 'success') {
        SetUserBankData(res.data.data)
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
        return false
     }
    }
    )
  }
  return (
    <div>
      <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
        <div className='overlay-box'>
          <Watch
            color="#ffffff"
            visible={spinnerLoading}
          />
        </div>
      </div>
      <Header />
      <section className='bg-gray-light section-small'>
        {/* <div className="container-fluid"> */}
        <div className="container">
          <div className='mpanel mg-b-15'>
            <div className='mpanel-header'>
              <h5 className='mg-b-0 fw600'>{MFData.pg_schemename}</h5>
            </div>
            <hr></hr>
            <div className='mpanel-body ecan-form'>
              <div className="row">
                <div className="col-lg-12">
                  <div className="ecan-form-group">
                    <label>Select Folio Number<span style={{ color: '#ff0000' }}>*</span></label>
                    <select onChange={(e) => redeemfundData(e.target.value)}>
                      <option value="">Select Folio</option>
                      {FoiloData.length > 0
                        ? FoiloData.map((key) => (
                          <>
                            <option value={key.pg_folio_no}>{key.pg_folio_no}</option>
                          </>
                        )) : ""}
                    </select>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <tr>
                        <th>Current Holdings</th>
                        <td className='tx-center'>{RedeemFoiloData.valueatnav}</td>
                      </tr>
                      <tr>
                        <th>Units Available</th>
                        <td className='tx-center'>{RedeemFoiloData.totalunits}</td>
                      </tr>
                      <tr>
                        <th>Redeem</th>
                        <td >
                          <select onChange={(e) => SetRedeemType(e.target.value)}>
                            <option value='A'>Amount</option>
                            <option value='U'>Unit(s)</option>
                            <option value='E'>Redeem All</option>
                          </select>
                        </td>
                      </tr>
                      {
                        RedeemType == 'A' || RedeemType == 'U' ?
                          <tr>
                            {RedeemType == 'U' ? <th>Unit(s)</th> : <th>Amount(Rs)</th>}
                            <td ><input type={'number'} onChange={(e) => SetRedeemVolume(e.target.value)} /></td>
                          </tr> : ''
                      }
                      <tr>
                        <th>Mandate Banks</th>
                        <td >
                          < div className='row'>
                            <div className='col-lg-11'>
                              <select name="bankno" value={Bankno} onChange={(e) => setBankno(e.target.value)} >
                                {UserBankData.crb_bank_acc_no1 != null ?
                                  <option value="1">{UserBankData.crb_bank1} -- {UserBankData.crb_bank_acc_no1.replace(/.(?=.{4})/g, 'X')} -- (Primary)</option> : ''
                                }
                                {UserBankData.crb_bank_acc_no2 != null ?
                                  <option value="2">{UserBankData.crb_bank2} -- {UserBankData.crb_bank_acc_no2.replace(/.(?=.{4})/g, 'X')}</option> : ''
                                }
                                {UserBankData.crb_bank_acc_no3 != null ?
                                  <option value="3">{UserBankData.crb_bank3} -- {UserBankData.crb_bank_acc_no3.replace(/.(?=.{4})/g, 'X')}</option> : ''
                                }
                              </select>
                            </div>
                            <div className='col-lg-1'>
                              <a href="/addmorebank"><img src="/img/bank.png" style={{ height: "40px" }}></img></a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div></div>
                {/* <div className="col-lg-12">
                    <div className="ecan-form-group">
                      <label>Amount<span style={{ color: '#ff0000' }}>*</span></label>
                      <input name="amount"  type="number"></input>
                    </div>
                  </div> */}
                <div className="theme-button mg-t-10">
                  {
                    errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                  }
                  <a className="btn" onClick={makeredeemtransaction}>
                    Proceed
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default MfRedeemDetail;